import React from "react";
import Home from "../pages/Home";
import BoardManager from "../pages/BoardManager";
import NotFound from "../pages/NotFound";
import {Route, Routes} from "react-router-dom";
import Board from "../pages/Board";
import Post from "../pages/Post";

const BoardManagerLevel = () => {
  return (
    <Routes>
      <Route path="Home/*" element={<Home />} />
      <Route path="Board/*" element={<Board />} />
      <Route path="Post/*" element={<Post />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default BoardManagerLevel;
